//ALL Label Of Dropdown
export const Transfer_From_City="Transfer From City"
export const Transfer_From_Branch="Transfer From Branch"
export const Transfer_To_Branch="Transfer To Branch"
export const Transfer_Date="Transfer Date"
export const Transfer_By_Vehicle="Transfer By Vehicle"
export const Select_Destination_City="Select Destination City"
export const Select_Destination_Branch="Select Destination Branch"
export const Booking_Type="Booking Type"
export const Payment_Type="Payment Type"
export const Consignment_Type="Consignment Type"
export const Driver_Name="Driver Name"
export const STATE="State"
export const SOURCE_CITY_OP="Source City (Optional)"
export const DESTOINATION_CITY_OP="Destination City (Optional)"
export const From_Booking_Date="From Booking Date "
export const To_Booking_Date="To Booking Date"
export const From_Receiving_Date="From Receiving Date "
export const To_Receiving_Date="To Receiving Date "
export const Transfer_From_Date="Transfer From Date"
export const Transfer_To_Date="Transfer To Date"
export const From_Date=" From Date"
export const To_Date=" To Date"





